// components/Loader.js
import React from 'react';

const Loader = ({ text, size, color }) => {
    return (
        <div class={`text-center spinner-${size} text-${color}`}>
             <p className="spinner-border "  role="status"></p>
             <span className="spin-text">{text}...</span>
        </div>
    );
};



export default Loader;
